/**
 * Atlas create-organization — derived Done-pill mission.
 *
 * Nothing is persisted: `readMissionState` in the adapter returns
 * `completed: true` whenever `ctx.hasOrg` is true. Because the app is gated
 * behind `RequireOrg`, this mission is always Done inside the app — it exists
 * to give the Atlas dock a visible "2 of N complete" early win, and to keep
 * the priority ordering symmetric with `add-first-product`.
 */
import type { AtlasMission } from '../atlas.types';

export const createOrganizationMission: AtlasMission = {
  id: 'create-organization',
  title: 'Create your organization',
  description: 'Relix is multi-tenant — every workspace starts with an organization.',
  kicker: 'Setup',
  entryRoute: '/onboarding',
  featureKey: '',
  storage: 'derived',
  critical: true,
  steps: [],
};
